import apiUser from "../../apiUser";

export const SET = 'RepairOrderStatuses/SET';

export function setRepairOrderStatuses(repairOrderStatuses) {
  return {
    type: SET,
    repairOrderStatuses
  }
}
